var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconToys(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-toys_svg__clip0_2952_509)",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.964 13.902a6.4 6.4 0 10-11.881 4.76 6.4 6.4 0 0011.88-4.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.003 15.488c-1.314-3.28-3.267-5.585-4.36-5.147-1.094.438-.915 3.453.4 6.734 1.314 3.28 3.266 5.585 4.36 5.147 1.093-.438.914-3.453-.4-6.734zM21.479 20.09c.287-1.554-.51-3.004-1.78-3.24-1.271-.234-2.534.835-2.821 2.388-.288 1.554.51 3.004 1.78 3.239 1.27.235 2.534-.834 2.82-2.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.317 7.667c0-.598.103-1.17.293-1.701A1.994 1.994 0 017 4c0-1.105.884-2 1.975-2 .852 0 1.577.545 1.855 1.31a4.869 4.869 0 012.425-.643c.881 0 1.709.233 2.425.643A1.977 1.977 0 0117.535 2c1.09 0 1.975.895 1.975 2 0 .978-.694 1.792-1.61 1.966.19.53.293 1.103.293 1.7 0 1.113-.359 2.14-.966 2.971.127.152.247.311.361.477.132-.081.273-.152.422-.211 1.186-.467 2.472-.003 2.871 1.036.4 1.04-.239 2.26-1.425 2.728a2.615 2.615 0 01-.62.16c.01.168.016.336.016.506 0 .576-.237 1.134-.352 1.667m-2 3.5c-1 1-1.354 1.26-2.5 1.442"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-toys_svg__clip0_2952_509"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconToys;